import React from 'react';

export const renderSlides = (slides) =>
  slides.map((slide) => (
    <div className="c-careers-featured-employees__slide">
      <div className="c-careers-featured-employees__slide-image">
        <img src={slide.photo.url} alt={slide.photo.alt} />
      </div>
      <div className="c-careers-featured-employees__slide-text">
        <div className="c-careers-featured-employees__slide-department color-black eyebrow-1">
          <span>{slide.department}</span>
        </div>
        <div className="c-careers-featured-employees__slide-name color-black h3-roobert">
          <h3>{slide.name}</h3>
        </div>
        <div className="c-careers-featured-employees__slide-position color-black body-2">
          <p>{slide.position}</p>
        </div>
        <div className="c-careers-featured-employees__slide-bio body-1 color-black">
          <p>{slide.bio}</p>
        </div>
      </div>
    </div>
  ));
